import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

export const LineWrapper = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLite};
`
export const CompletedLineWrapper = styled.div`
  position: absolute;
  z-index: 0;
  max-width: 325px;
  top: 18px;
  left: 0;
  border-bottom: 2px solid ${({ theme }) => theme.colors.brand};
  width: ${({ width }) => width && `${width}%;`};
  transition: 0.5s;
`
export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(52px, 1fr));

  /* cursor: pointer; */
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
`

export const NumberContainer = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.background};
  border: 2px solid ${({ theme }) => theme.colors.backgroundLite};
  color: ${({ theme }) => theme.colors.secondary};

  font-size: 14px;
  font-weight: 500;

  ${({ theme, active }) => active && `background-color: ${theme.colors.brand} !important;`};
  ${({ theme, active }) => active && `color: ${theme.colors.background} !important;`};
  ${({ theme, active }) => active && `border: 2px solid ${theme.colors.brand} !important;`};

  ${({ theme, completed }) => completed && `color: ${theme.colors.brand} !important;`};
  ${({ theme, completed }) => completed && `border: 2px solid ${theme.colors.brand} !important;`};
  transition: 0.5s;
`

export const LabelContainer = styled.div`
  font-size: 12px;
  font-weight: 400;

  color: ${({ theme }) => theme.colors.secondary};

  ${({ theme, active }) => active && `color: ${theme.colors.brand} !important;`};
  ${({ theme, completed }) => completed && `color: ${theme.colors.brand} !important;`};
`
